import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import type { ILegalDependencyConditionsProps } from '../../../Interfaces/ILegalDependency';
import { LegalDependencyConditionGroup } from './LegalDependencyConditionGroup';

export const LegalDependencyConditions = ({
  conditionGroups,
  getRequirementOption,
  getStatusLabel,
  getTransactionOption,
  isLoadingLegalTransactions,
  isTransactionLoading,
  legalRequirementStates,
  onAddCondition,
  onChangeCondition,
  onChangeGroupOperator,
  onRemoveCondition,
  onRemoveGroup,
  requirementOptionsByTransaction,
  transactionOptions,
}: ILegalDependencyConditionsProps) => (
  <Card variant='outlined' sx={{ height: '100%', borderRadius: 3 }}>
    <CardContent sx={{ p: 2.5 }}>
      <Stack spacing={2.25}>
        <Box>
          <Stack alignItems='center' direction='row' spacing={1}>
            <Chip color='info' label='Wenn' size='small' />
            <Typography variant='subtitle1'>Bedingungen</Typography>
          </Stack>
          <Typography color='text.secondary' variant='body2'>
            Beschreibe, unter welchen Voraussetzungen die Regel greifen soll.
          </Typography>
        </Box>

        <Stack spacing={1.5}>
          {conditionGroups.map((group, groupIndex) => (
            <LegalDependencyConditionGroup
              getRequirementOption={getRequirementOption}
              getStatusLabel={getStatusLabel}
              getTransactionOption={getTransactionOption}
              group={group}
              groupIndex={groupIndex}
              groupLoading={group.conditions.some(condition =>
                isTransactionLoading(condition.transactionId)
              )}
              isLoadingLegalTransactions={isLoadingLegalTransactions}
              isTransactionLoading={isTransactionLoading}
              key={group.id}
              legalRequirementStates={legalRequirementStates}
              onAddCondition={() => onAddCondition(group.id)}
              onChangeCondition={(conditionId, updates) =>
                onChangeCondition(group.id, conditionId, updates)
              }
              onChangeOperator={operator =>
                onChangeGroupOperator(group.id, operator)
              }
              onRemoveCondition={conditionId =>
                onRemoveCondition(group.id, conditionId)
              }
              onRemoveGroup={() => onRemoveGroup(group.id)}
              removeGroupDisabled={conditionGroups.length === 1}
              requirementOptionsByTransaction={requirementOptionsByTransaction}
              transactionOptions={transactionOptions}
            />
          ))}
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);
